import { render } from "./TraitRanksBOTBCard.vue?vue&type=template&id=d3e31ae2"
import script from "./TraitRanksBOTBCard.vue?vue&type=script&lang=js"
export * from "./TraitRanksBOTBCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__